"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SubjectCategoryStatusType;
(function (SubjectCategoryStatusType) {
    SubjectCategoryStatusType["ACTIVE"] = "active";
    SubjectCategoryStatusType["DISABLED"] = "disabled";
    SubjectCategoryStatusType["DELETED"] = "deleted";
})(SubjectCategoryStatusType || (SubjectCategoryStatusType = {}));
exports.default = SubjectCategoryStatusType;
//# sourceMappingURL=subjectCategoryStatusType.js.map